import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const Person2StateTrueNotiTrueIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "Person2StateTrueNotiTrueIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M15.5569 14.0922H7.12152C4.8492 14.0922 3 15.9761 3 18.2922V20.8277C3 21.4754 3.5153 22.0001 4.15043 22.0001H18.5516V21.9953C19.1754 21.9819 19.6789 21.4671 19.6789 20.8277V18.2922C19.6789 15.9761 17.8297 14.0922 15.5569 14.0922Z"
        fill="url(#paint0_linear_23_9510)"
      />
      <path
        d="M12.6008 5.59345C12.6008 4.8004 12.8002 4.06111 13.1246 3.39611C12.5735 3.16427 11.9717 3.03247 11.3395 3.03247C8.74887 3.03247 6.64085 5.1808 6.64085 7.82106C6.64085 10.4606 8.74888 12.6089 11.3395 12.6089C13.1174 12.6089 14.649 11.5852 15.4468 10.0972C13.7708 9.31188 12.6008 7.59647 12.6008 5.59345Z"
        fill="url(#paint1_linear_23_9510)"
      />
      <path
        d="M17.4742 9.18626C19.4215 9.18626 21.0001 7.57756 21.0001 5.59313C21.0001 3.6087 19.4215 2 17.4742 2C15.5269 2 13.9482 3.6087 13.9482 5.59313C13.9482 7.57756 15.5269 9.18626 17.4742 9.18626Z"
        fill="#FC3B26"
      />
      <defs>
        <linearGradient
          id="paint0_linear_23_9510"
          x1="3"
          y1="14.2687"
          x2="19.6789"
          y2="14.2687"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DD3422" />
          <stop offset="1" stopColor="#FC3B26" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_23_9510"
          x1="3"
          y1="14.2687"
          x2="19.6789"
          y2="14.2687"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#DD3422" />
          <stop offset="1" stopColor="#FC3B26" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Person2StateTrueNotiTrueIcon;
